import React, { useEffect, useState } from "react";
import { getAccountDetails, updateAccountDetails } from "../api/account";
import AccountTable from "@components/AccountTable";
import { useAuth } from "../context/AuthContext";
// ❌ BrandingCard removed from here

const AccountPage: React.FC = () => {
  const { businessId } = useAuth();
  const [accountData, setAccountData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!businessId) return;

    const fetchAccount = async () => {
      try {
        const data = await getAccountDetails();
        setAccountData(data);
      } catch (error) {
        // silent fail
      } finally {
        setLoading(false);
      }
    };

    fetchAccount();
  }, [businessId]);

  const handleSave = async (updatedData: any) => {
    if (!businessId) return;

    try {
      await updateAccountDetails(updatedData);
      setAccountData((prev: any) => ({ ...prev, ...updatedData }));
    } catch (error) {
      // silent fail
    }
  };

  // loading state
  if (!businessId || loading) {
    return (
      <p className="text-gray-600 text-center mt-6">⏳ Loading...</p>
    );
  }

  // derive slug from whatever the API returns
  const slug =
    accountData?.slug ??
    accountData?.business_slug ??
    accountData?.booking_slug ??
    "";

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-6">
      {accountData ? (
        <>
          <AccountTable
            name={accountData.name}
            address={accountData.address}
            phone={accountData.phone}
            email={accountData.email}
            operating_hours={accountData.operating_hours}
            description={accountData.description}
            timezone={accountData.timezone}
            slug={slug}
            onSave={handleSave}
          />
          {/* BrandingCard removed – now handled on its own Branding page */}
        </>
      ) : (
        <p className="text-gray-600 text-center">
          No account data available. Please check your business details.
        </p>
      )}
    </div>
  );
};

export default AccountPage;
